/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useState } from "react";
import { Form, Checkbox, Tabs, Row, Col } from "antd";
import MapPropsContext from "../MapPropsContext";
import Title from "antd/lib/typography/Title";
import StyledTableHeader from "../../../styled-components/StyledTableHeader";
import StyledCheckBoxWithLabel from "../../../styled-components/StyledCheckboxWithLabel";
import { TI_SELECT_YEAR_COMBO } from "../../../Constants";

const OPTIONS_SERVICE = [
  { service_code: "2G", label: "2G" },
  { service_code: "3G", label: "3G" },
  { service_code: "LTE", label: "LTE" },
  { service_code: "5G", label: "5G" },
];

const OPTIONS_CLS = [
  { cls_code: "32", label: "기지국" },
  // {cls_code: "구현중1", label: "기지국(2G)"},
  // {cls_code: "구현중2", label: "기지국(3G)"},
  // {cls_code: "구현중3", label: "기지국(4G)"},
  { cls_code: "94", label: "간이무선국" },
  { cls_code: "44", label: "육상무선국" },
  { cls_code: "85", label: "이동중계국" },
  { cls_code: "49", label: "이동국" },
  { cls_code: "92", label: "아마추어국" },
  { cls_code: "42", label: "의무선박국" },
  { cls_code: "41", label: "선박국" },
  { cls_code: "21", label: "고정국" },
  { cls_code: "CMFL", label: "전파응용설비" },
  { cls_code: "OTHER", label: "기타" },
  { cls_code: "5G", label: "5G" },
];

function WidgetCodeForStats() {
  const { widgetState, onChangeWidgetState } = useContext(MapPropsContext);
  const { service_code_stats_list, cls_code_stats_list, isClsSearch } = widgetState;

  const [state1, setState1] = useState({
    indeterminate: service_code_stats_list.length < OPTIONS_SERVICE.length,
    checkAll: service_code_stats_list.length === OPTIONS_SERVICE.length,
  });

  const onChange1 = useCallback(
    (checkedValues) => {
      setState1({
        indeterminate: !!checkedValues.length && checkedValues.length < OPTIONS_SERVICE.length,
        checkAll: checkedValues.length === OPTIONS_SERVICE.length,
      });
      onChangeWidgetState({ target: { name: "service_code_stats_list", value: checkedValues } });
    },
    [onChangeWidgetState, setState1]
  );

  const onCheckAllChange1 = useCallback(({ target: { checked } }) => {
    setState1({
      indeterminate: false,
      checkAll: checked,
    });
    onChangeWidgetState({
      target: {
        name: "service_code_stats_list",
        value: !checked ? [] : OPTIONS_SERVICE.map(({ service_code }) => service_code),
      },
    });
  }, []);

  const [state2, setState2] = useState({
    indeterminate: cls_code_stats_list.length < OPTIONS_CLS.length,
    checkAll: cls_code_stats_list.length === OPTIONS_CLS.length,
  });

  const onChange2 = useCallback(
    (checkedValues) => {
      setState2({
        indeterminate: !!checkedValues.length && checkedValues.length < OPTIONS_CLS.length,
        checkAll: checkedValues.length === OPTIONS_CLS.length,
      });

      onChangeWidgetState({ target: { name: "cls_code_stats_list", value: checkedValues } });
    },
    [onChangeWidgetState, setState1]
  );

  const onCheckAllChange2 = useCallback(({ target: { checked } }) => {
    setState2({
      indeterminate: false,
      checkAll: checked,
    });
    onChangeWidgetState({
      target: {
        name: "cls_code_stats_list",
        value: !checked ? [] : OPTIONS_CLS.map(({ cls_code }) => cls_code),
      },
    });
  }, []);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", margin: "10 0" }}>
        <h3>무선국종 검색</h3>
        <StyledCheckBoxWithLabel
          label="전체 선택"
          checked={state2.checkAll}
          onChange={onCheckAllChange2}
          tabIndex={TI_SELECT_YEAR_COMBO + 1}
        />
      </div>

      <Row>
        {OPTIONS_CLS.map(({ cls_code, label }, index) => (
          <Col span={12} key={cls_code}>
            <StyledCheckBoxWithLabel
              tabIndex={TI_SELECT_YEAR_COMBO + 2 + index}
              checked={cls_code_stats_list.includes(cls_code)}
              label={label}
              onChange={() => {
                const index = cls_code_stats_list.indexOf(cls_code);
                let checkedValues = [...cls_code_stats_list];
                if (index === -1) {
                  checkedValues.push(cls_code);
                } else {
                  checkedValues.splice(index, 1);
                }

                setState2({
                  indeterminate: !!checkedValues.length && checkedValues.length < OPTIONS_CLS.length,
                  checkAll: checkedValues.length === OPTIONS_CLS.length,
                });

                onChangeWidgetState({ target: { name: "cls_code_stats_list", value: checkedValues } });
              }}
            />
            {/* <Checkbox value={cls_code} key={cls_code}>
              {label}
            </Checkbox> */}
          </Col>
        ))}
      </Row>

      {/* <Tabs.TabPane tab="무선국종 검색" key={true}>
          <Checkbox checked={state2.checkAll} indeterminate={state2.indeterminate} onChange={onCheckAllChange2}>
            전체 선택
          </Checkbox>
          <Checkbox.Group
            name="cls_code_stats_list"
            value={cls_code_stats_list}
            onChange={onChange2}
            size={"small"}
            style={{ width: "100%" }}
            disabled={!isClsSearch}
          >
            <Row>
              {OPTIONS_CLS.map(({ cls_code, label }) => (
                <Col span={12} key={cls_code}>
                  <Checkbox value={cls_code} key={cls_code}>
                    {label}
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </Tabs.TabPane>
      </Tabs> */}
    </div>
  );
}

export default WidgetCodeForStats;
